'use strict';

export default class AddConfController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getConf(this.$stateParams.id);
  }

  getApp(id) {
    this.$http.get('/api/apks/' + id).then(response => {
      this.app = response.data;
    });
  }

  getConf(id) {
    this.$http.get('/api/AppConfs/' + id).then(response => {
      this.conf = response.data;
      this.getApp(this.conf.app);
    });
  }

  save() {
    this.$http.put(`api/AppConfs/${this.$stateParams.id}`, this.conf).then(response => {
      this.$state.go('appstore.show', {
        id: this.conf.app
      });
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/appstore/editConf/editConf.controller.js